export default __webpack_public_path__ + "static/media/10.e61b908c.jpeg";